import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';
import './panel.css';
import frm from './formAux.js'
import { mode } from "d3"
// import stripe from 'stripe';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';



// console.log( 'sss', stripe )


var descriptor = {};
var origDescriptor = null;

function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}

var stripe = null;


function CompanyBilling(prop) {
    function saveModel(callback) {

    }
    let companyFields = ['newname','registername','domain','billingContactName', 'billingContactEmail','billingContactPhone'];

    var elements = null;

    async function payModal( company ) {
        let intent = (await window.post('payment_intent', {product:'monthly1'})).data;
        console.log( 'intent', intent )
        frm.myAlert('Payment', `
            <div id="payment_element"></div>
        `, 'Pay', payAction, 'Cancel' );
        const appearance = {
            theme: "stripe",
            // theme: 'flat',
            variables: {
                colorPrimary: "#00ff36",
                colorBackground: "#4400b8",
                colorDanger: "#ff9800",
                colorText: "#FFF",
                borderRadius: "0",
            },
        };
        elements = stripe.elements({ ...appearance, ...intent });
    
        const paymentElement = elements.create("payment");
        console.log( 'paymentElement', paymentElement )

        paymentElement.mount("#payment_element");
    }

    async function payAction(ev) {
        ev.preventDefault();
        let response = await stripe.confirmPayment({
            elements,
            // confirmParams: {
            //     // Make sure to change this to your payment completion page
            //     // return_url: "http://localhost:8080/checkout.html",
            // },
            redirect: "if_required",
        });
        console.log( 'payment response', response )
        if( response.error ) {
            let msg = response.error.message.toString();
            console.log( 'msg', msg )
            frm.myAlert('Payment Error', msg, 'Ok')
        }
        else {
            frm.myAlert('Payment Successful', "Payment ID: " + response.paymentIntent.id + "<br>Ammount: " + (response.paymentIntent.amount/100).toFixed(2), 'Ok')
        }
    }


    async function initCompany() {
        const key = "pk_test_51LYviWSDSAcuQj6RmUjLutrJOAAoBVrH2tZYOyAL2y3M9tJw00XUoJ4SWnI13VZ0SN5X9V2Cuv1Ln9vYQMSgaf7J001U8ldRGz"
        stripe = await loadStripe(key)
        let company = {active:true,priv:''};
        let add = 1;
        window.topBarVisible()
        let params = window.getParams();
        if( params.company == 'new') {
            company.priv = Object.keys(window.privs).filter( v => v != 'admin').join(',')
        }
        else {
            if( !params.company ) params.company = window.GlobalVars.userCurrentRole.company;
            let res = await window.post('find_companies',{match:{_id:params.company}})
            company = res.data.records[0];
            add = 0;
        }
        $('#paybtn').on('click', (ev) => {
            payModal( company );
        })
    }


    useEffect(function (a) {
        initCompany();
    });

    return (
        <div fluid="md p-0" className="maincontent">
            <div className="row">
                    <div className="wizzbtn">
                        <Button id="savebtn" variant="primary" type="button" className="ml-3 btn btn-primary"><i class=" mr-2 fa fa-floppy-o"></i> Save</Button>
                        <Button id="delbtn" variant="danger" type="button" className="ml-2 mr-3 btn btn-danger hidden"><i className="fa fa-trash-o mr-2"></i> Delete Company</Button>
                    </div>
                <div className="col-5">
                    <div className="project-panel">
                        <div className="step2 type-Classification">
                            <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                    <h1>Payment Test</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapse1" className="collapse show" aria-labelledby="headingEight" >
                                    <button className="btn btn-primary" id="paybtn">Pay</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-7">
                    <div className="project-panel">
                        {/* <div className="step2 type-Classification">
                            <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse2">
                                    <h1>Billing Contact</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapse3" className="collapse" aria-labelledby="headingEight" >
                                    <input placeholder="Billing Contact Name" type="text" id="billingContactName" className="mb-4 form-control" />
                                    <input placeholder="Billing Contact Email" type="text" id="billingContactEmail" className="mb-4 form-control" />
                                    <input placeholder="Billing Contact Phone Number" type="text" id="billingContactPhone" className="mb-4 form-control" />
                                    <div className="payment" id="payment"></div>
                                </div>
                            </div>
                        </div>
                        <div className="step2 type-Classification">
                            <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapse10" aria-expanded="true" aria-controls="collapse2">
                                    <h1>Selected Plan</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapse10" className="collapse show" aria-labelledby="headingEight" >
                                    <div id="tiers">Enterprise</div>
                                </div></div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

var defaultCustomNerTestPayload = {
    "text": {
        "1": "This is a text by Michael Smith",
        "2": "A paper from Oxford University"
    }
};

export default CompanyBilling
